import { useProjectDataShares } from '@/viewmodel/features/dataShare/hooks/useProjectDataShares';

export function useDataShareCount(projectId: string | undefined): number | undefined {
  const { shares } = useProjectDataShares(projectId);
  return projectId
    ? shares.filter((share) => share.provider_project_id === projectId).length
    : undefined;
}
